module.exports = __webpack_public_path__ + "img/barcode.5825eff6.svg";